<template>
    <secondary-button
        color="primary"
        :on="on"
        :class="textTransformNormal ? 'text-none' : ''"
        @click="$emit('click', $event)"
    >
        <icon
            v-if="icon"
            left
            :size="20"
            :icon="icon"
        />
        <slot />
    </secondary-button>
</template>

<script>
export default {
    name: "ActionButton",
    props: {
        bindProps: {
            type: Object,
            default: null
        },
        icon: {
            type: String,
            default: "PlusSquare"
        },
        textTransformNormal: {
            type: Boolean,
            default: false
        },
        on: {
            type: Object,
            default: null
        }
    }
}
</script>
